import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function initTabs($, VisSense, isMobile) {
  'use strict';

  function startProgressBarAnimation(selector, interval) {
    selector.animate({
      width: 100 + '%'
    }, {
      duration: interval,
      easing: 'linear'
    });
  }

  function stopProgressBarAnimation(selector) {
    selector.stop();
    selector.css({
      width: 0
    });
  }

  function InteractiveBlockTabs(element, options) {
    var defaults = {
      autoSwitchInterval: 10000,
      withAutoSwitch: true
    };
    var self = this;
    var scrolledToTheBlock = false;
    this.settings = $.extend({}, defaults, options);
    this.$element = $(element);
    this.$tabs = $('.js-tabs-item', this.$element);
    this.$section = this.$element.parents('.com-sec-info-1__back');
    this.$images = $('.js-tabs-content', this.$element);
    this.$info = $('.com-sec-info-1__tabs-info', this.$element);
    this.switcherId = null;

    if (this.$info.length) {
      this.settings.withAutoSwitch = false;
    }

    if (!isMobile.phone && this.settings.withAutoSwitch) {
      var visibility = VisSense(this.$section[0], {
        fullyvisible: 0.6
      });
      visibility.monitor({
        fullyvisible: function fullyvisible() {
          if (!scrolledToTheBlock) {
            self.startAutoSwitch();
            scrolledToTheBlock = true;
          }
        }
      }).start();
    }

    this.$tabs.on('click', function () {
      toggleTab($(this));
    });

    function toggleTab($tab) {
      self.$tabs.removeClass('is-active');
      self.$images.removeClass('is-active');
      var $section = self.$section;
      $section.removeClass(function (index, className) {
        return (className.match(/(^|\s)com-sec-info-1__back--\S+/g) || []).join(' ');
      });
      $tab.addClass('is-active');
      $tab.parents('.js-tabs').find('[data-tab="' + $tab.attr('id') + '"]').addClass('is-active');
      $section.addClass('com-sec-info-1__back--' + $tab.data('background') + '');

      if (self.switcherId) {
        self.stopAutoSwitch();
      }
    }
  }

  InteractiveBlockTabs.prototype.startAutoSwitch = function () {
    var $firstItem = this.$tabs.first();
    var $activeItem = $('.js-tabs-item.is-active', this.$element);
    var self = this;
    var $progressBar = $('.js-progress-bar', $activeItem);
    startProgressBarAnimation($progressBar, this.settings.autoSwitchInterval);
    this.switcherId = setInterval(switchTab, this.settings.autoSwitchInterval);

    function switchTab() {
      var $activeItem = $('.js-tabs-item.is-active', self.$element),
          $nextItem = $activeItem.parent().next().find('.js-tabs-item');
      $progressBar = $('.js-progress-bar', $activeItem);
      stopProgressBarAnimation($progressBar);
      self.$section.removeClass(function (index, className) {
        return (className.match(/(^|\s)com-sec-info-1__back--\S+/g) || []).join(' ');
      });

      if (!$nextItem.length) {
        self.$images.removeClass('is-active');
        self.$tabs.removeClass('is-active');
        $progressBar = $('.js-progress-bar', $firstItem);
        startProgressBarAnimation($progressBar, self.settings.autoSwitchInterval);
        $firstItem.addClass('is-active');
        $firstItem.parents('.js-tabs').find('[data-tab="' + self.$tabs.attr('id') + '"]').addClass('is-active');
        self.$section.addClass('com-sec-info-1__back--' + $firstItem.data('background') + '');
      } else {
        self.$images.removeClass('is-active');
        self.$tabs.removeClass('is-active');
        $progressBar = $('.js-progress-bar', $nextItem);
        startProgressBarAnimation($progressBar, self.settings.autoSwitchInterval);
        $nextItem.addClass('is-active');
        $nextItem.parents('.js-tabs').find('[data-tab="' + $nextItem.attr('id') + '"]').addClass('is-active');
        self.$section.addClass('com-sec-info-1__back--' + $nextItem.data('background') + '');
      }
    }
  };

  InteractiveBlockTabs.prototype.stopAutoSwitch = function () {
    stopProgressBarAnimation($('.js-progress-bar'));

    if (this.switcherId) {
      clearInterval(this.switcherId);
      this.switcherId = null;
    }
  };

  InteractiveBlockTabs.prototype.setActiveTabByIndex = function (i) {
    var $item = this.$tabs.eq(i);

    if ($item.length > 0) {
      this.toggleTab($item);
    }
  };

  InteractiveBlockTabs.prototype.toggleTab = function ($tab) {
    this.$tabs.removeClass('is-active');
    this.$images.removeClass('is-active');
    var $section = this.$section;
    $section.removeClass(function (index, className) {
      return (className.match(/(^|\s)com-sec-info-1__back--\S+/g) || []).join(' ');
    });
    $tab.addClass('is-active');
    $tab.parents('.js-tabs').find('[data-tab="' + $tab.attr('id') + '"]').addClass('is-active');
    $section.addClass('com-sec-info-1__back--' + $tab.data('background') + '');

    if (this.switcherId) {
      this.stopAutoSwitch();
    }
  };

  $.fn.interactiveBlockTabs = function (options) {
    this.each(function () {
      if (!$.data(this, 'plugin_interactiveBlockTabs')) {
        $.data(this, 'plugin_interactiveBlockTabs', new InteractiveBlockTabs(this, options));
      }
    });
    return this;
  };

  $(function () {
    var $tabs = $('.js-tabs');
    $tabs.interactiveBlockTabs();
  });
}

export default {
  init: function () {
    var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var isBrowser, jQuery, _yield$import, VisSenseFactory, VisSense, _yield$import2, isMobile;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isBrowser = true;

              if (!isBrowser) {
                _context.next = 16;
                break;
              }

              _context.next = 4;
              return import('jquery');

            case 4:
              jQuery = _context.sent;
              window.$ = window.jQuery = jQuery["default"];
              _context.next = 8;
              return import('vissense');

            case 8:
              _yield$import = _context.sent;
              VisSenseFactory = _yield$import["default"];
              VisSense = VisSenseFactory(window);
              _context.next = 13;
              return import('ismobilejs');

            case 13:
              _yield$import2 = _context.sent;
              isMobile = _yield$import2["default"];
              initTabs(jQuery["default"], VisSense, isMobile);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }()
};